export const navigation = (() => {
    const toggleBtn = document.querySelectorAll("button[aria-controls='mainnav']");
    const header = document.getElementById("header");
    const megaTriggers = document.querySelectorAll(".mainNav-button");

    if (header) {
        if (header.querySelector('.siteMessage')) {
            header.classList.add("header--site-message");
        } else {
            header.classList.remove("header--site-message");
        }
    }

    toggleBtn[0].addEventListener("click", function () {
        header.classList.toggle("header--open");
        document.documentElement.classList.toggle("menu-open");
    });

    const mainNavButtons = document.querySelectorAll(".mainNav-button");
    Array.from(mainNavButtons).forEach((toggleBtn) => addEL(toggleBtn));

    function addEL(toggleBtn) {
        toggleBtn.addEventListener("click", function (event) {
            Array.from(mainNavButtons).forEach((b) => {
                if (event.target.classList.contains("mainNav-button--action")) {
                    event.preventDefault();
                }
                if (b === this) {
                    if (this.querySelector('.mainNav-button--action').getAttribute("aria-expanded") === "true") {
                        this.classList.add("open");
                    } else {
                        this.classList.remove("open");
                    }
                    return;
                } else {
                    b.classList.remove("open");
                }

                let theId = b.getAttribute("aria-controls");

                b.setAttribute("aria-expanded", "false");

                let target = document.getElementById(theId);
                if (!target) return;

                target.setAttribute("aria-hidden", "true");
                target.classList.add("hidden");
            });
        });
    }

    document.addEventListener("click", (e) => {
        if (!e.target.closest(".header-mainNav")) {
            Array.from(megaTriggers).forEach((trigger) => {
                if (trigger.getAttribute("aria-expanded") === "true") {
                    trigger.setAttribute("aria-expanded", "false");
                    let target = document.getElementById(trigger.getAttribute("aria-controls"));
                    target.setAttribute("aria-hidden", "true");
                    target.classList.add("hidden");
                }
            });
        }
    });
})();
